import React from 'react';

import { Flex, Text } from 'Components/Base';

import GainScoreBarChart from './GainScoreBarChart';
import MasteryBarChart from './MasteryBarChart';
import BloomBarChart from './BloomBarChart';

// Occupies the same footprint as a chart (Box width:100%) so the 3 columns stay
// equal width even when this one only shows a message.
const GrowthUnavailable = () => (
  <Flex
    alignItems="center"
    justifyContent="center"
    p={5}
    style={{
      width: '100%',
      minHeight: '240px',
      border: '1px dashed #d0d0d0',
      borderRadius: '10px',
    }}
  >
    <Text textAlign="center" color="#888">
      มีข้อมูลระดับพัฒนาการในระดับหน่วยการเรียนรู้เท่านั้น
    </Text>
  </Flex>
);

export const LearningResultBarCharts = ({ activeBar, setActiveBar, stats }) => {
  const { gainScore, mastery, bloom, showGrowth } = stats;
  // Growth (gain score) exists at unit level only. When a lesson is selected the
  // backend returns showGrowth=false; show a note instead of a misleading 0% chart.
  const hasGrowth = showGrowth !== false;
  return (
    <Flex style={{ margin: '24px 0', columnGap: '16px' }}>
      {hasGrowth ? (
        <GainScoreBarChart
          activeBar={activeBar}
          setActiveBar={setActiveBar}
          gainScore={gainScore}
        />
      ) : (
        <GrowthUnavailable />
      )}
      <MasteryBarChart activeBar={activeBar} setActiveBar={setActiveBar} mastery={mastery} />
      <BloomBarChart activeBar={activeBar} setActiveBar={setActiveBar} bloom={bloom} />
    </Flex>
  );
};

export default LearningResultBarCharts;
